import { ArticleCollections } from './collection.article';
import type { WithCollections } from './collection.common';
import { PageSetCollections } from './collection.pageset';

interface BookmarkCommon<T extends BookmarkType> extends WithCollections {
    id: string;
    created: Date;
    ownerId: string;
    bookmarkType: T;
}

interface BookmarkArticle extends BookmarkCommon<BookmarkType.article> {
    articleId: string;
}

interface BookmarkPageSet<T extends BookmarkType.pageSet | BookmarkType.pages> extends BookmarkCommon<T> {
    pageSetId: string;
    pageSet: {
        id: string;
    };
}

type BookmarkPageSetOrPages = BookmarkPageSet<BookmarkType.pageSet> | BookmarkPageSet<BookmarkType.pages>;

type BookmarkByType<T extends BookmarkType> = { bookmarkType: T } & (T extends BookmarkType.pageSet
    ? BookmarkPageSet<BookmarkType.pageSet>
    : T extends BookmarkType.pages
    ? BookmarkPageSet<BookmarkType.pages>
    : T extends BookmarkType.article
    ? BookmarkArticle
    : unknown);

type BookmarkAny = BookmarkByType<BookmarkType>;

enum BookmarkType {
    article = 1,
    pages = 2,
    pageSet = 3,
}

enum CollectionContentTypes {
    article = 1,
    pageSet = 2,
}

type ContentCollections = ArticleCollections | PageSetCollections;

export {
    BookmarkCommon,
    BookmarkArticle,
    BookmarkPageSet,
    BookmarkByType,
    BookmarkType,
    BookmarkAny,
    CollectionContentTypes,
    BookmarkPageSetOrPages,
    ContentCollections,
};
